import React from "react";
import VouchersForm from "./vouchersFormWrapper/VouchersForm";

export default function VouchersFormWrapper({ADD_VOUCHER, UPDATE_VOUCHER, user}){
    let props = {
        ADD_VOUCHER, 
        UPDATE_VOUCHER,
        user
    };
    
    return (
        <VouchersForm props={props}/>
    );
}


// WEBPACK FOOTER //
// ./src/components/general/VouchersFormWrapper.jsx